import { page } from '$app/state'
import { SvelteURL } from 'svelte/reactivity'

export function params(params: Record<string, string | number | null>, url?: URL): string {
	// Create a new URL object with the current URL
	const current = new SvelteURL((url ?? page.url).href)

	// Iterate over the params object and set the search params
	Object.entries(params).forEach(([key, value]) => {
		if (value === null) current.searchParams.delete(key)
		else current.searchParams.set(key, String(value))
	})

	// Return the new URL as a string; no base path, so nothing for `resolve` to add
	return current.pathname + current.search + current.hash
}
